
import { Mixins, Component, Watch } from 'vue-property-decorator';
import {
  Collapse,
  CollapseItem,
  Option,
  Select,
  Button,
} from 'element-ui';
import BsMixin from '@/views/Home/mixins/bsMixin';
import api from '@/api/set';
import { tSearch } from '@/components/Search/index';
import tData from './components/data.vue';
import bModal from './components/bModal.vue';

@Component({
  components: {
    Collapse,
    CollapseItem,
    Option,
    Select,
    Button,
    tData,
    bModal,
    tSearch,
  },
})

export default class normal extends Mixins(BsMixin) {
}
